import { render, staticRenderFns } from "./propiedadFamiliaProductoAdd.vue?vue&type=template&id=08611853&scoped=true&"
import script from "./propiedadFamiliaProductoAdd.vue?vue&type=script&lang=js&"
export * from "./propiedadFamiliaProductoAdd.vue?vue&type=script&lang=js&"
import style0 from "./propiedadFamiliaProductoAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./propiedadFamiliaProductoAdd.vue?vue&type=style&index=1&id=08611853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08611853",
  null
  
)

export default component.exports